/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import PT from 'prop-types'
import RRPT from 'react-router-prop-types'
import appScreenshot from './images/yaaro_phone.webp'
import featurePic from './images/featpic.webp'
import btnGoogle from './images/btn_google.webp'
import './index.scss'

import { androidDownloadUrl4X } from '../../constants/def'
import Carousel from '../../components/Carousel'

const FEATURE_CARDS = [
  {
    id: 'travel-map',
    accent: '#38BDF8',
    title: 'Explore Global Travel Map',
    content:
      'Start your voice journey on our exclusive global travel route map. Wander through the Eiffel Tower, Maldives, Mount Fuji, Santorini and more world-famous landmarks, explore exotic cultures with just your voice.',
  },
  {
    id: 'check-in',
    accent: '#F472B6',
    title: 'Meet Friends & Gift While Checking-in',
    content:
      'Make global friends by checking in scenic spots! Send exclusive travel-themed gifts to users from different countries, share travel stories, and build deep connections across regions.',
  },
  {
    id: 'voice-rooms',
    accent: '#A78BFA',
    title: 'Hot Scenic Voice Rooms',
    content:
      'Join thousands of lively themed voice rooms with global scenic backgrounds. Party with hundreds of users, chat freely, sing and interact in immersive exotic atmosphere.',
  },
  {
    id: 'cp-date',
    accent: '#FB923C',
    title: 'Sweet Travel-Style CP Date',
    content:
      'Build your exclusive travel-themed CP room. Wander starry Santorini, sunset beaches and romantic views with your lover via voice. Experience immersive sweet companionship even long-distance apart.',
  },
  {
    id: 'family-pk',
    accent: '#34D399',
    title: 'Epic Family Voice PK',
    content:
      'Gather your family members, create your scenic-themed clan. Compete with other families in mic-seat PK, win glory with your partners, and gain strong belonging in exciting voice battles.',
  },
]

const SHOWCASE_HIGHLIGHTS = [
  {
    id: 'roam',
    title: 'Voice-First Cloud Roaming',
    content:
      'Combine virtual travel with real-time voice chat for an immersive social experience beyond dry text chats.',
  },
  {
    id: 'landmarks',
    title: 'Iconic Landmarks, Live Voices',
    content:
      'Hop between world-famous scenic spots and meet warm people from every corner of the globe.',
  },
  {
    id: 'rooms',
    title: 'Themed Rooms Around the Clock',
    content:
      'Party, sing, and connect in scenic voice rooms whenever inspiration strikes.',
  },
]

class Home extends React.Component {
  state = {
    contactVisible: false,
  }

  componentDidMount () {}

  hideContactAlert = () => {
    this.setState({
      contactVisible: false,
    })
  }

  showContactAlert = () => {
    this.setState({
      contactVisible: true,
    })
  }

  getYear = () => new Date().getFullYear()

  openDownload = () => {
    window.open(androidDownloadUrl4X, '_blank')
  }

  render () {
    const appScreenshots = [{ id: 'yaaroApp', src: appScreenshot }]

    return (
      <div className="Home">
        <Helmet>
          <title>Yaaro – Chat & Roam the World by Voice</title>
          <style>{`body { background-color: #0F1729; }`}</style>
        </Helmet>

        <header className="Home__header">
          <div className="Home__logo" aria-label="Yaaro" />Yaaro
        </header>

        <section className="Home__hero">
          <h1 className="Home__heroTitle">
            Yaaro: Chat &amp; Roam the World by Voice
          </h1>
          <p className="Home__heroSubtitle">
            Roam the globe without stepping out, connect with people from all
            corners of the world through voice on Yaaro.
          </p>
          <p className="Home__heroIntro">
            Yaaro is a one-of-a-kind voice-first social platform themed on
            global famous scenic spots. We combine virtual travel with real-time
            voice chat, breaking the dull &ldquo;dry chat&rdquo; of traditional
            social apps, bringing you immersive cloud-roaming social experience.
          </p>
          {/* <div className="Home__heroCta">
            <img
              src={btnGoogle}
              alt="Get Yaaro on Google Play"
              className="Home__featureBtn"
              onClick={this.openDownload}
            />
          </div> */}
        </section>

        {/* <section className="Home__features">
          <div className="Home__features-box">
            <div className="Home__featuresGrid">
              {FEATURE_CARDS.map(card => (
                <article
                  key={card.id}
                  className="Home__CardP"
                  style={{ '--card-accent': card.accent }}
                >
                  <h3 className="Home__CardTitle">{card.title}</h3>
                  <p className="Home__CardContent">{card.content}</p>
                </article>
              ))}
            </div>
            <div className="Home__CardTop">
              <p className="Home__CardTitleH1">
                On Yaaro, every voice connects a story, every chat is a
                wonderful journey. Come and roam the world with your voice,
                meet warm people here.
              </p>
            </div>
            <div className="Home__featuresbtn">
              <img
                src={btnGoogle}
                alt="Get Yaaro on Google Play"
                className="Home__featureBtn"
                onClick={this.openDownload}
              />
            </div>
          </div>
          <div className="Home__featurePic">
            <img src={featurePic} alt="Yaaro app preview" />
          </div>
        </section> */}

        <section className="Home__block">
          <div className="Home__phoneMockup">
            <Carousel images={appScreenshots} />
          </div>
          <div className="Home__block-box">
            <div className="Home__block_title">
              <div className="Home__block_title_left">
                <h3 className="Home__CardTitle">Experience Yaaro on the Go</h3>
                <p>
                  Your passport to voice-powered cloud roaming — explore scenic
                  spots, join live rooms, and connect worldwide from anywhere.
                </p>
              </div>
              {/* <div className="Home__block_title_right">
                <img
                  src={btnGoogle}
                  alt="Get Yaaro on Google Play"
                  onClick={this.openDownload}
                />
              </div> */}
            </div>
            {SHOWCASE_HIGHLIGHTS.map(item => (
              <div key={item.id} className="Home__CardB">
                <h3 className="Home__CardTitle">{item.title}</h3>
                <p className="Home__CardContent">{item.content}</p>
              </div>
            ))}
            <div className="Home__CardB Home__CardB--cta">
              <h3 className="Home__CardTitle">
                Download Yaaro — every voice is a journey waiting to begin.
              </h3>
            </div>
          </div>
        </section>

        <footer className="Home__footer">
          <div className="Home__footerBar">
            <a href="/yaaro/about/userAgreement">User Agreement</a>
            <a href="/yaaro/about/privacyAgreement">Privacy Policy</a>
            <div
              className="Home__contact"
              onMouseLeave={this.hideContactAlert}
              onMouseEnter={this.showContactAlert}
            >
              Contact Us
              {this.state.contactVisible && (
                <div className="Home__contactWrap">
                  Mail: report@yaarolive.com
                </div>
              )}
            </div>
          </div>
          <div className="Home__companyInfo">
            {`Cribstock Inc · ${this.getYear()}`}
          </div>
        </footer>
      </div>
    )
  }
}

Home.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  history: RRPT.history.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  userAgent: PT.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  hostname: PT.string.isRequired,
}

Home.defaultProps = {}

export default connect(state => {
  const {
    env: { userAgent, hostname },
  } = state
  return { userAgent, hostname }
})(Home)
